import {
  type ActionCreatorWithPayload,
  createSlice,
  type PayloadAction,
} from '@reduxjs/toolkit';
import { type DataThemeOptions } from '@saviynt/design-system';

import { ALERT_BANNER_DEFAULT } from '../constants';
import { type AlertBannerState, type GlobalState, GlobalType } from '../types';

const initialState: GlobalState = {
  dataTheme: null as DataThemeOptions,
  globalDateFormat: 'MMM dd, yyyy',
  isGlobalLoading: true,
  isGlobalError: false,
  globalErrorReason: '',
  mediaQueryValue: 0,
  alertBanner: ALERT_BANNER_DEFAULT,
};

const globalSlice = createSlice({
  name: GlobalType.SLICE_NAME,
  initialState,
  reducers: {
    setGlobalAlertBanner: (state, action: PayloadAction<AlertBannerState>) => {
      state.alertBanner = action.payload;
    },
  },
});

const { reducer: globalReducer, actions } = globalSlice;

interface GlobalActions {
  setGlobalAlertBanner: ActionCreatorWithPayload<AlertBannerState>;
}

export const globalActions = actions as GlobalActions;

export default globalReducer;
